import { createRouter, createWebHistory } from 'vue-router'
import HomeView from "@/views/HomeView.vue";
import PrefixReferencedDois from "@/views/PrefixReferencedDois.vue";
import PrefixReferencedOrcids from "@/views/PrefixReferencedOrcids.vue";
import MembersList from "@/views/MembersList.vue";
import PrefixDois from "@/views/PrefixDois.vue";
import AboutView from "@/views/AboutView.vue";
import RadarView from "@/views/RadarView.vue";
import MonthlySynthesisView from "@/views/MonthlySynthesisView.vue";
import QuarterlyHorizonView from "@/views/QuarterlyHorizonView.vue";
import CrossrefAnalyticsView from "@/views/CrossrefAnalyticsView.vue";

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/doi/:id?',
    name: 'doi',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ './views/DoiView.vue')
  },
  {
    path: '/prefix/info',
    name: 'prefixInfo',
    component: () => import(/* webpackChunkName: "about" */ './views/PrefixInfo.vue')
  },
  {
    path: '/prefix/dois',
    name: 'prefixDois',
    component: PrefixDois
  },
  {
    path: '/prefix/referenced/dois',
    name: 'prefixReferencedDois',
    component: PrefixReferencedDois
  },
  {
    path: '/prefix/referenced/orcids',
    name: 'prefixReferencedOrcids',
    component: PrefixReferencedOrcids
  },
  {
    path: '/members',
    name: 'members',
    component: MembersList
  },
  {
    path: '/table',
    name: 'tablePagination',
    component: () => import(/* webpackChunkName: "about" */ './samples/SamplePage.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import(/* webpackChunkName: "about" */ './samples/ParentComponent.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/radar',
    name: 'radar',
    component: RadarView
  },
  {
    path: '/monthly-synthesis',
    name: 'monthlySynthesis',
    component: MonthlySynthesisView
  },
  {
    path: '/quarterly-horizon',
    name: 'quarterlyHorizon',
    component: QuarterlyHorizonView
  },
  {
    path: '/crossref-analytics',
    name: 'crossrefAnalytics',
    component: CrossrefAnalyticsView
  },
  { path: '/:pathMatch(.*)*', name: 'error', component: Error },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
